/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocio } from '../../conexiones';
import IEstadosDetalles from './entidades/estadosDetalles';

export default class ModeloEstadosDetalles {
    public consultarEstadosDetalles() {
        return manejadorRest<IRespuesta<IEstadosDetalles>>(() =>
            negocio.get('EstadosDetalles/ConsultarListaEstadosDetalles')
        );
    }
    public crearEstadosDetalles(estadosDetalles: IEstadosDetalles) {
        return manejadorRest<IRespuesta<IEstadosDetalles>>(() =>
            negocio.post('EstadosDetalles/GuardarEstadosDetalles', estadosDetalles)
        );
    }
    public editarEstadosDetalles(estadosDetalles: IEstadosDetalles) {
        return manejadorRest<IRespuesta<IEstadosDetalles>>(() =>
            negocio.put('EstadosDetalles/EditarEstadosDetalles', estadosDetalles)
        );
    }
    public eliminarEstadosDetalles(estadosDetalles: IEstadosDetalles) {
        return manejadorRest<IRespuesta<IEstadosDetalles>>(() =>
            negocio.delete('EstadosDetalles/EliminarEstadosDetalles', estadosDetalles)
        );
    }
}
